import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import {
  DEFAULT_SUBSCRIPTION,
  fetchSubscription,
  SubscriptionSummary,
} from './subscriptionApi';

export function useSubscription() {
  const { authChecked, user } = useAuth();
  const [subscription, setSubscription] =
    useState<SubscriptionSummary>(DEFAULT_SUBSCRIPTION);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!authChecked || !user) {
      setSubscription(DEFAULT_SUBSCRIPTION);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      setSubscription(await fetchSubscription());
    } finally {
      setLoading(false);
    }
  }, [authChecked, user]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { subscription, loading, refresh };
}
